import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import fieldNames from './filenameTemplateFields';

const SavedFormatPreview = ({ filenameTemplate }) => {


  const folderPath =
    filenameTemplate.savedRootFolder + '/' +
    filenameTemplate.savedFolderPathFields.map( field => {
      const foundField = _.find(fieldNames, { name: field });
      return foundField && foundField.preview ? foundField.preview(filenameTemplate) : field
    }).join('');

  const folderPathwIcons = _.filter(folderPath.split('/')) // split into components, filtering out any empty ones
    .map(component => (
      <span>
        <i className="fa fa-folder" style={{ color: 'orange' }} />&nbsp;
        {component}
      </span>
    ));

  // Render Sample Filename
  const fileName = filenameTemplate.savedFileFormatFields.map( field => {
    const foundField = _.find(fieldNames, { name: field });
    return foundField && foundField.preview ? foundField.preview(filenameTemplate) : field
  }).join('') + '.pdf';

  const fileNamewIcon = (
    <span>
      <i className="fa fa-file" style={{ color: '#04547B' }} />&nbsp;
      {fileName}
    </span>
  );

  return (
    <div className="preview-template-container">
      <div className="label">File Format Currently In Use</div>
      <div className="preview-template">

        { _.reduceRight(folderPathwIcons.concat(fileNamewIcon), (item, acc) => (
          <ul>
            <li>
              { acc }
              { item }
            </li>
          </ul>
        ), []) }
      </div>
    </div>
  );
};

SavedFormatPreview.propTypes = {
  filenameTemplate: PropTypes.object.isRequired,
};

export default SavedFormatPreview;



// WEBPACK FOOTER //
// ./src/Integrations/connections/FilenameTemplate/SavedFormatPreview.jsx